'use client';
import classNames from 'classnames';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import { BtnThreeProps } from 'eco-design-micro/props/btn/BtnThreeProps';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import { ProductCardProps } from 'eco-design-micro/props/product/const';
import getLocal from 'eco-design-reliance/getLocal';
import EcoButton from 'eco-design/base/eco-button';
import EcoCalculator from 'eco-design/base/eco-calculator';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import React, { useState } from 'react';
import IconAdd from './comps/IconAdd';
import './index.scss';
import { LangText } from './text/LangText';

export interface EcoBundle1ItemSubItemProps extends ProductCardProps {
    /**
     * 购买数量
     */
    quantity?: number;
    /**
     * 样式名
     */
    className?: string;
}
export interface EcoBundle1ItemProps extends BtnThreeProps {
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 图片上标题
     */
    imgTitle?: React.ReactNode;
    /**
     * 图片
     */
    pc?: string;
    /**
     * 主标题
     */
    title?: React.ReactNode;
    /**
     * 副标题
     */
    subTitle?: React.ReactNode;
    /**
     * 描述
     */
    descItems?: React.ReactNode[];
    /**
     * 当前价
     */
    price?: number;
    /**
     * 对比价
     */
    compareAtPrice?: number;
    /**
     * 会员价
     */
    memberPrice?: number;
    /**
     * 库存
     */
    inventoryQuantity?: number;
    /**
     * 2级
     */
    subItems?: EcoBundle1ItemSubItemProps[];
    /**
     * 样式名
     */
    className?: string;
    /**
     * 是否开启 affirm
     */
    isOpenAffirm?: boolean;
    /**
     * 是否隐藏对比价
     */
    isHidePriceCompareAt?: boolean;
}
const getPriceAllHandle = (item: EcoBundle1ItemProps, subItems: EcoBundle1ItemSubItemProps[]) => {
    let totalPrice = item.price || 0;
    let totalCompareAt = item.compareAtPrice || 0;
    for (let i = 0; i < subItems.length; i++) {
        const subItemA = subItems[i];
        // 价格
        let itemPriceA = 0;
        if (subItemA.price && subItemA.quantity) {
            itemPriceA = subItemA.price * subItemA.quantity;
        }
        if (itemPriceA) {
            totalPrice += itemPriceA;
        }
        // 对比价
        let itemCompareAtPriceA = 0;
        if (subItemA.priceCompareAt && subItemA.quantity) {
            itemCompareAtPriceA = subItemA.priceCompareAt * subItemA.quantity;
        }
        if (itemCompareAtPriceA) {
            totalCompareAt += itemCompareAtPriceA;
        }
    }

    return {
        totalPrice,
        totalCompareAt,
    };
};
/**
 * bundle-1
 */
export default function EcoBundle1Item({ theme, ...item }: EcoBundle1ItemProps) {
    const prefixCls = 'eco-bundle-1-card';
    const compCls = classNames(prefixCls, {});
    const descItems = item.descItems || [];
    const [subItems, setSubItems] = useState(item.subItems || []);
    const { locale = 'us' } = getLocal();
    const TextA = LangText[locale] || LangText['us']; //固定文案
    const hasSub = subItems.length > 0;
    const hasBtnChild1 = !!item.lChildren;
    const hasBtnChild2 = !!item.rChildren;
    const priceObjA = getPriceAllHandle(item, subItems);

    // 子级数量变化
    const subQuantityChange = (index: number, quantity: number) => {
        const subItems2 = JSON.parse(JSON.stringify(subItems));
        subItems2[index].quantity = quantity;
        setSubItems(subItems2);
    };
    return (
        <div className={compCls}>
            <div className={`${prefixCls}-img-title`}>{item.imgTitle}</div>
            <div className={`${prefixCls}-img`}>
                <EcoImg pc={item.pc} />
            </div>
            <div className={`${prefixCls}-msg`}>
                <div className={`${prefixCls}-title`}>{item.title}</div>
                <div className={`${prefixCls}-subTitle`}>{item.subTitle}</div>
                <ul className={`${prefixCls}-desc`}>
                    {descItems.map((descItem: React.ReactNode, index: number) => {
                        return (
                            <li key={index} className={`${prefixCls}-desc-item`}>
                                {descItem}
                            </li>
                        );
                    })}
                </ul>
                <div className={`${prefixCls}-msg-btns`}>
                    <EcoButton lChildren={item.cChildren} lType={item.cType} lIsWithRightArrow={item.cIsWithRightArrow}></EcoButton>
                </div>
                {hasSub && (
                    <div className={`${prefixCls}-sub`}>
                        <div className={`${prefixCls}-sub-alsoNeed`}>{TextA.alsoNeed}</div>
                        {subItems.map((subItem: EcoBundle1ItemSubItemProps, index: number) => {
                            return (
                                <div className={`${prefixCls}-sub-item`} key={index}>
                                    <div className={`${prefixCls}-sub-item-img`}>
                                        <EcoImg pc={subItem.pc} />
                                    </div>
                                    <div className={`${prefixCls}-sub-item-msg`}>
                                        <div className={`${prefixCls}-sub-item-title`}>{subItem.title}</div>
                                        <div className={`${prefixCls}-sub-item-price-box`}>
                                            <div className={`${prefixCls}-sub-item-price-price`}>
                                                {subItem.price ? FormatMoneyLocal(subItem.price, locale) : null}
                                            </div>
                                            <div className={`${prefixCls}-sub-item-price-priceCompareAt`}>
                                                {subItem.priceCompareAt ? FormatMoneyLocal(subItem.priceCompareAt, locale) : null}
                                            </div>
                                        </div>
                                        <div className={`${prefixCls}-sub-item-calculator`}>
                                            <EcoCalculator
                                                {...subItem}
                                                theme={theme}
                                                onChange={(quantity: number) => {
                                                    subQuantityChange(index, quantity);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            <div className={`${prefixCls}-footer`}>
                <div className={`${prefixCls}-price-box`}>
                    {!!priceObjA.totalPrice && (
                        <div className={`${prefixCls}-price-now`}>
                            {TextA.Now} {FormatMoneyLocal(priceObjA.totalPrice, locale)}
                        </div>
                    )}
                    {!!priceObjA.totalCompareAt && (
                        <div className={`${prefixCls}-price-old`}>
                            {TextA.MSRP} {item.isHidePriceCompareAt ? 'XXX' : FormatMoneyLocal(priceObjA.totalCompareAt, locale)}
                        </div>
                    )}
                </div>

                {item.isOpenAffirm && (
                    <div className={`${prefixCls}-affirm`}>
                        <div className={`${prefixCls}-affirm-img`}></div>
                        <div className={`${prefixCls}-affirm-msg`}>{TextA.affirm1}</div>
                    </div>
                )}
                <div className={`${prefixCls}-footer-btns`}>
                    {hasBtnChild1 && (
                        <EcoLink
                            className={`${prefixCls}-footer-btn ${prefixCls}-footer-btn-outlined ${item.lDisabled ? `${prefixCls}-footer-btn-disabled` : ''}`}
                            href={item.lHref}
                            dataLayer={item.lDataLayer}
                        >
                            {item.lChildren}
                            <IconAdd />
                        </EcoLink>
                    )}
                    {hasBtnChild2 && (
                        <EcoLink
                            className={`${prefixCls}-footer-btn ${
                                item.rDisabled || (item.inventoryQuantity ?? 0) <= 0 ? `${prefixCls}-footer-btn-disabled` : ''
                            }`}
                            href={item.rHref}
                            dataLayer={item.rDataLayer}
                        >
                            {item.rChildren}
                            <IconAdd />
                        </EcoLink>
                    )}
                </div>
            </div>
        </div>
    );
}
